import api from "./api";

const interviewService = {
  async evaluateAnswers(payload) {
    const { data } = await api.post("/interview/evaluate", payload);
    return data?.data || data;
  },
};

export default interviewService;
